import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import LeaderboardRoundedIcon from '@mui/icons-material/LeaderboardRounded';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { createGetRankingListOutbound } from '../../api/outbound/commonOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
export const MedalPanelRankingsButton = ({ rankingType }) => {
    const socketSend = useSocketSend();
    const onClick = useCallback(() => {
        socketSend(createGetRankingListOutbound(rankingType));
    }, [rankingType, socketSend]);
    return (_jsx(Button, { onClick: onClick, variant: 'outlined', size: 'small', startIcon: _jsx(LeaderboardRoundedIcon, {}), children: "Rankings" }));
};
